// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isObject = (item?: any): boolean => {
  return item && typeof item === 'object' && !Array.isArray(item)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mergeDeep = (target: { [key: string]: any }, source: { [key: string]: any }): { [key: string]: any } => {
  const output = Object.assign({}, target)
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, { [key]: source[key] })
        else output[key] = mergeDeep(target[key], source[key])
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }

  return output
}

export default mergeDeep
